var LinkCardHandler = /** @class */ (function () {
    function LinkCardHandler(props) {
        this.init = this.init.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.wrapper = props.wrapper;
        this.primaryHref = this.getPrimaryHref(props.primaryHrefElement);
        this.init();
    }
    LinkCardHandler.prototype.getPrimaryHref = function (element) {
        if (element instanceof HTMLAnchorElement) {
            return element.href;
        }
        else if (this.wrapper.querySelector('a')) {
            return this.wrapper.querySelector('a').href;
        }
        return undefined;
    };
    LinkCardHandler.prototype.handleClick = function (event) {
        var target = event.target;
        if (target && !target.href) {
            event.preventDefault();
            if (this.primaryHref) {
                window.location.href = this.primaryHref;
            }
        }
    };
    LinkCardHandler.prototype.init = function () {
        if (this.primaryHref) {
            this.wrapper.style.cursor = 'pointer';
            this.wrapper.addEventListener('click', this.handleClick);
        }
    };
    return LinkCardHandler;
}());
export { LinkCardHandler };
export default LinkCardHandler;
